<template>
    <div v-if="show">
      <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>
      <hp5-base-card padding-size-selection="md">
        <div class="promoted-services">
          <img :src="imageInfo.src" />
          <div>
            <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
            <hp5-heading size-selection="sm" tag-selection="h3">{{ headerInfo }}</hp5-heading>
            <hp5-semantic size-selection="md"
              ><p>{{ descriptionInfo }}</p></hp5-semantic
            >
            <div class="services-links" v-if="locations">
              <div v-for="(location, index) in locations" :key="location.id" class="location-link">
                <hp5-link-text-basic size="md" :href="locationDetailUrl(location.id)" :text="location.address.city" target="_blank" />
                <span v-if="index < locations.length - 1" class="separator"></span>
              </div>
            </div>
          </div>
        </div>
      </hp5-base-card>
      <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>
    </div>
</template>
<script setup>

      const { promotedServices, profile, context, plan } = useFCPModel()
      const { locationDetailUrl } = useUrls(context.value)
  
      //checks if the current plan has smart Care flag
      const isSmartCare = plan.value ? plan.value.isSmartCare : false
      const PTDesc = 'As a Pipe Trade Services MN member, you and your family can get free care at these clinics.'
      const SCDesc = 'In-network primary care is available at your SmartCare clinic.'
      const imageInfo = computed(() => (isSmartCare ? { src: '/fcp/csearch/smartcare.png' } : { src: '/fcp/csearch/pipe-trades-wellness.png' }))
      const headerInfo = computed(() =>
        isSmartCare ? 'Your SmartCare plan covers all of your health needs.' : 'Member only benefits for pipe trader services'
      )
      const descriptionInfo = computed(() => (isSmartCare ? SCDesc : PTDesc))

      const locations = computed(() => {
        if (promotedServices.value && promotedServices.value.locations && promotedServices.value.locations.length > 0) {
          return promotedServices.value.locations.sort((a, b) => (a.address.city > b.address.city ? 1 : -1))
        }
        return null
      })
  
      const show = computed(() => {
        return locations.value && locations.value.length > 0
      })

</script>
  
<style lang="scss" scoped>
@use '~/assets/scss/breakpoints' as *;
  
  label {
    padding-left: 10px;
  }
  
  .promoted-services {
    @include small-up {
      display: grid;
      grid-template-columns: auto 11fr;
      column-gap: var(--spacing-md);
      img {
        width: 325px;
        height: auto;
      }
    }
    @include small {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>

<style lang="scss">
  .services-links {
    .location-link {
      display: inline;
    }
    .separator {
      display: inline-block;
      border-left: 2px solid var(--color-text-base);
      margin-right: var(--spacing-sm);
      margin-left: var(--spacing-sm);
      height: 18px;
      vertical-align: text-bottom;
    }
  }
  </style>